import React from 'react';
import { ArrowRightIcon, CheckIcon, CalendarIcon, UserIcon, TargetIcon, ClockIcon, BriefcaseIcon } from 'lucide-react';
import { PageTransition } from '../../components/layout/PageTransition';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { DecorativeShape } from '../../components/DecorativeShape';
import { Animate } from '../../components/ui/Animate';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
export function EmbeddedPartner() {
  const {
    t
  } = useLanguage();
  const signs = t('embeddedPartner.signs') as string[];
  const roles = t('embeddedPartner.roles') as string[];
  const whatWeDoItems = t('embeddedPartner.whatWeDoItems') as string[];
  return <PageTransition data-id="element-1589" data-mp="2ju247o0pdnay">
      <div className="pt-12 pb-24" data-id="element-1590" data-mp="2julcse4gqzcb">
        {/* Hero */}
        <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1591" data-mp="2jrz3a8y0i9rg">
          <DecorativeShape type="blob" color="bg-blue-100/50" className="top-0 right-0 w-[500px] h-[500px] translate-x-1/4 -translate-y-1/4 -z-10" data-id="element-1592" data-mp="2oqsic5sy68tq" />
          <Animate className="max-w-3xl" data-id="element-1593" data-mp="3ft89trzrmnzi">
            <span className="inline-block px-4 py-2 bg-blue-50 text-blue-700 font-medium rounded-full text-sm mb-6" data-id="element-1594" data-mp="3auww366cntc0">
              {t('embeddedPartner.badge')}
            </span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-1595" data-mp="7eq4vz54fok4">
              {t('embeddedPartner.title')}
              <br data-id="element-1596" data-mp="2f4wyz7z45v9" />
              <span className="text-blue-600" data-id="element-1597" data-mp="2goeet5d8mym">
                {t('embeddedPartner.titleHighlight')}
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-1598" data-mp="3ts7ukok5qiqe">
              {t('embeddedPartner.intro1')}
            </p>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-1599" data-mp="q4z9ffodrsez">
              {t('embeddedPartner.intro2')}
            </p>
            <Link to="/contact" data-id="element-1600" data-mp="ldphu9j9uf0g">
              <Button size="lg" rightIcon={<ArrowRightIcon size={20} data-id="element-1602" data-mp="2fmmnmgawhvuc" />} data-id="element-1601" data-mp="lcefme5h5fbg">
                {t('embeddedPartner.heroCta')}
              </Button>
            </Link>
          </Animate>
        </section>

        {/* Practical details strip */}
        <section className="bg-blue-50 py-12 mb-20" data-id="element-1603" data-mp="25x33l7bgbvxw">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1604" data-mp="25ugwf8sh3ig7">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1605" data-mp="2aubmxb8c660q">
              <Animate data-id="element-1606" data-mp="1wvbya3ktpr4k">
                <div className="flex items-start gap-4" data-id="element-1607" data-mp="1wutqqaspnqhc">
                  <div className="p-3 bg-white rounded-xl shadow-sm flex-shrink-0" data-id="element-1608" data-mp="21uycogce1dey">
                    <ClockIcon size={24} className="text-blue-600" data-id="element-1609" data-mp="21slk79907knn" />
                  </div>
                  <div data-id="element-1610" data-mp="1mzs5vr5gxakk">
                    <p className="font-bold text-charcoal mb-1" data-id="element-1611" data-mp="1rwij86pw1s2a">
                      {t('embeddedPartner.detail1Title')}
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-1612" data-mp="3hd00pitg1m67">
                      {t('embeddedPartner.detail1Desc')}
                    </p>
                  </div>
                </div>
              </Animate>
              <Animate delay={0.1} data-id="element-1613" data-mp="1anzfeqz2fyly">
                <div className="flex items-start gap-4" data-id="element-1614" data-mp="15od5aqejayhd">
                  <div className="p-3 bg-white rounded-xl shadow-sm flex-shrink-0" data-id="element-1615" data-mp="15pxyabl7a9d4">
                    <TargetIcon size={24} className="text-blue-600" data-id="element-1616" data-mp="1keaun9o79u85" />
                  </div>
                  <div data-id="element-1617" data-mp="1flhs8sg7exz8">
                    <p className="font-bold text-charcoal mb-1" data-id="element-1618" data-mp="1fky6t1rchrgg">
                      {t('embeddedPartner.detail2Title')}
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-1619" data-mp="1pcm59mmbk8rf">
                      {t('embeddedPartner.detail2Desc')}
                    </p>
                  </div>
                </div>
              </Animate>
              <Animate delay={0.2} data-id="element-1620" data-mp="1yciqtfdewri9">
                <div className="flex items-start gap-4" data-id="element-1621" data-mp="1ydk1vjufhdzz">
                  <div className="p-3 bg-white rounded-xl shadow-sm flex-shrink-0" data-id="element-1622" data-mp="8xkm3jwb0qbd">
                    <BriefcaseIcon size={24} className="text-blue-600" data-id="element-1623" data-mp="3yzn1nssgcoi" />
                  </div>
                  <div data-id="element-1624" data-mp="5g6ppsf3ctfx">
                    <p className="font-bold text-charcoal mb-1" data-id="element-1625" data-mp="5gokslq0p1m9">
                      {t('embeddedPartner.detail3Title')}
                    </p>
                    <p className="text-gray-600 text-sm" data-id="element-1626" data-mp="adeyx3i9hn51">
                      {t('embeddedPartner.detail3Desc')}
                    </p>
                  </div>
                </div>
              </Animate>
            </div>
          </div>
        </section>

        {/* Signs */}
        <section className="bg-cream py-20 mb-20" data-id="element-1627" data-mp="3iwe0mmi3pgcj">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1628" data-mp="3nu5wfrlv9mm0">
            <Animate className="mb-12" data-id="element-1629" data-mp="3nufodkqh23uc">
              <h2 className="text-3xl font-bold text-charcoal" data-id="element-1630" data-mp="3ssph7ooq4scs">
                {t('embeddedPartner.signsTitle')}
              </h2>
            </Animate>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1631" data-mp="1fw97ltoakmt">
              {signs.map((sign, i) => <Animate key={i} delay={i * 0.05} data-id="element-1632" data-mp="302h7ml897g9t" data-mpi={i}>
                  <div className="flex items-start gap-3 bg-white rounded-2xl p-5 shadow-sm" data-id="element-1633" data-mp="352mrvgc720hv">
                    <div className="mt-0.5 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1634" data-mp="1m8tq0ko5l0xg">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1635" data-mp="1i6oufge59u86" />
                    </div>
                    <span className="text-gray-700" data-id="element-1636" data-mp="1d7c9x2aqwz8r">{sign}</span>
                  </div>
                </Animate>)}
            </div>
          </div>
        </section>

        {/* What I can be embedded as */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1637" data-mp="13appgemc0a79">
          <Animate className="mb-10" data-id="element-1638" data-mp="yiftagumidwj">
            <h2 className="text-3xl font-bold text-charcoal mb-2" data-id="element-1639" data-mp="yhekkj12y3hz">
              {t('embeddedPartner.rolesTitle')}
            </h2>
            <p className="text-gray-500" data-id="element-1640" data-mp="uf02w295d9sa">
              {t('embeddedPartner.rolesSubtitle')}
            </p>
          </Animate>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1641" data-mp="kjpw717t0e86">
            {roles.map((role, i) => <Animate key={i} delay={i * 0.05} data-id="element-1642" data-mp="fjttr6er8uuq" data-mpi={i}>
                <div className="flex items-start gap-3 bg-gray-50 rounded-2xl p-5" data-id="element-1643" data-mp="fm6hy1b3w1g8">
                  <div className="mt-0.5 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1644" data-mp="5v6cjna3ucyr">
                    <UserIcon size={14} data-id="element-1645" data-mp="awvqbaopp4qj" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-1646" data-mp="3t1yw6xmi5ks0">{role}</span>
                </div>
              </Animate>)}
          </div>
        </section>

        {/* How it works */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20" data-id="element-1647" data-mp="ompgbwbydv1u">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-1648" data-mp="tlsmjk3o67be">
            <Animate data-id="element-1649" data-mp="tnwohwi0cw91">
              <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-1650" data-mp="fux69mqucnxs">
                {t('embeddedPartner.whatWeDoTitle')}
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-1651" data-mp="juxw03je4lk5">
                {t('embeddedPartner.whatWeDoP1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1652" data-mp="1ccjqg64w15ie">
                {t('embeddedPartner.whatWeDoP2')}
              </p>
            </Animate>
            <Animate delay={0.1} data-id="element-1653" data-mp="2x1nrgawmufth">
              <div className="space-y-3" data-id="element-1654" data-mp="2x0m7ti1jwl05">
                {whatWeDoItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1655" data-mp="2s21gk84a1bnu" data-mpi={i}>
                    <div className="mt-1 p-1 rounded-full bg-blue-50 text-blue-600 flex-shrink-0" data-id="element-1656" data-mp="36s8pnx8e9ibv">
                      <CheckIcon size={14} strokeWidth={3} data-id="element-1657" data-mp="31u77rfmpfp1z" />
                    </div>
                    <span className="text-gray-700" data-id="element-1658" data-mp="2e55wzlqeg1tj">{item}</span>
                  </div>)}
              </div>
            </Animate>
          </div>
        </section>

        {/* CTA */}
        <section className="max-w-4xl mx-auto px-4 text-center" data-id="element-1659" data-mp="2o3bxq00gz1wt">
          <Animate data-id="element-1660" data-mp="2j3h1ri1u7m4w">
            <Card className="p-12 bg-gradient-to-br from-blue-50 to-indigo-50 border-0" data-id="element-1661" data-mp="2j2xucv9tcg54">
              <div className="w-16 h-16 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-1662" data-mp="3bjq4v78b8vp">
                <CalendarIcon size={32} className="text-blue-600" data-id="element-1663" data-mp="3uhkw4pcc7cah" />
              </div>
              <h2 className="text-3xl font-bold mb-4" data-id="element-1664" data-mp="1rwgysi1xa7rf">
                {t('embeddedPartner.ctaTitle')}
              </h2>
              <p className="text-gray-600 mb-8 max-w-xl mx-auto" data-id="element-1665" data-mp="1wvbo82ueauki">
                {t('embeddedPartner.ctaDesc')}
              </p>
              <Link to="/contact" data-id="element-1666" data-mp="21s23wp2afo5e">
                <Button variant="primary" rightIcon={<ArrowRightIcon size={18} data-id="element-1668" data-mp="2bjoohc0imzkt" />} data-id="element-1667" data-mp="26kv89btugugy">
                  {t('embeddedPartner.ctaCta')}
                </Button>
              </Link>
            </Card>
          </Animate>
        </section>
      </div>
    </PageTransition>;
}